import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import MathUtils from 'mewe/utils/math-utils';
import { openPostbox } from 'mewe/utils/dialogs-common';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwFile extends Component {
  @service router;
  @service account;
  @service dynamicDialogs;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);

    installDropdown(this, 'dropdownOptions');
  }

  get document() {
    return this.args.file.post?.document || this.args.file.document || this.args.file.audio;
  }

  get owner() {
    return this.args.file.owner || this.args.file.post.owner || this.document.owner;
  }

  // hack until backend has its act together
  get fileType() {
    let type = this.document.type;

    if (type) {
      return type;
    } else {
      let name = this.document.name;
      if (name) {
        return name.toLowerCase().slice(name.lastIndexOf('.') + 1);
      }
    }
    return undefined;
  }

  get createdAt() {
    return this.args.file.createdAt || this.args.file.post.createdAt;
  }

  get documentSize() {
    return MathUtils.getDocumentSizeText(this.document.size);
  }

  get documentDownloadUrl() {
    let url = this.document._links.url?.href || this.document._links.self.href;
    return `${url}?download`;
  }

  get theme() {
    let theme = this.args.scope;

    if (theme === 'chat') {
      if (this.args.thread.isGroupChat) {
        theme = 'group';
      } else if (this.args.thread.isEventChat) {
        theme = 'event';
      } else {
        theme = 'privacymail';
      }
    }

    return theme;
  }

  @action
  openProfile() {
    this.routing.transitionTo('app.publicid', [this.owner.id]);
  }

  @action
  repostTo(target) {
    const file = this.args.file;
    if (file && file.audio) {
      file.audio.id = file.id;
    }
    let document = file.document || file.audio;
    openPostbox(
      {
        target: target,
        preselectedFiles: [document],
      },
      this.dynamicDialogs
    );
  }
}
